import { useSetDeadline } from "@/orval/gen"
import { showErrorNotification } from "@/utils/form-submission-notifications"
import { CancelButton, SubmitButton } from "@components/Buttons"
import { getDateOnly } from "@components/date-only"
import { DefaultModal } from "@components/default-modal"
import { FormButtonGroup } from "@components/form-button-group"
import { ModalProps, Stack, Textarea } from "@mantine/core"
import { DateInput } from "@mantine/dates"
import { useForm } from "@mantine/form"
import { useQueryClient } from "@tanstack/react-query"
import { useTranslation } from "react-i18next"

interface Props extends ModalProps {
  contractId: number
  statusId: number | undefined
}

export function SetDeadlineModal({
  contractId,
  statusId,
  ...modalProps
}: Props) {
  const form = useForm({
    mode: "uncontrolled",
    initialValues: {
      deadlineDate: getDateOnly(),
      note: null,
    },
  })
  const { t } = useTranslation("app_server")
  const queryClient = useQueryClient()
  const { mutate: setDeadline } = useSetDeadline({
    mutation: {
      onError: showErrorNotification,
      onSuccess: () => {
        queryClient.invalidateQueries()
        modalProps.onClose()
      },
    },
  })
  const handleSubmit = (values: typeof form.values) => {
    if (!statusId) return
    setDeadline({ data: { ...values, approvalStatusId: statusId, contractId } })
  }

  return (
    <DefaultModal {...modalProps}>
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Stack>
          <DateInput
            label={t("Date")}
            key={form.key("deadlineDate")}
            {...form.getInputProps("deadlineDate")}
          />
          <Textarea
            label={t("Note")}
            key={form.key("note")}
            {...form.getInputProps("note")}
          />
          <FormButtonGroup>
            <CancelButton onClick={modalProps.onClose} />
            <SubmitButton>{t("Confirm")}</SubmitButton>
          </FormButtonGroup>
        </Stack>
      </form>
    </DefaultModal>
  )
}
